import { AppAddPhotoArgs, SetWaitingHandler } from "@eatbetter/ui-shared/dist";
import { DeletePhotoArgs, PhotoRefInternal } from "@eatbetter/photos-shared";
import { uploadPhoto } from "@eatbetter/ui-shared";
import { ThunkAction } from "../AdminRedux";

export const addPhoto = (args: AppAddPhotoArgs, setWaiting?: SetWaitingHandler): ThunkAction<PhotoRefInternal> => {
  return async (_dispatch, _state, deps) => {
    // NOTE - THIS IS DUPLICATED IN PhotoThunks.ts
    const uploadInfo = await deps.api.withThrow(setWaiting).getUploadPhotoRequestInfo({
      dimensions: args.dimensions,
      mediaType: args.mediaType,
    });

    await uploadPhoto(uploadInfo.data, args.uri);

    const photoRef: PhotoRefInternal = {
      type: "internal",
      id: uploadInfo.data.photoId,
    };

    return photoRef;
  };
};

export const deletePhoto = (args: DeletePhotoArgs, setWaiting?: SetWaitingHandler): ThunkAction<void> => {
  return async (_dispatch, _state, deps) => {
    await deps.api.withThrow(setWaiting).deletePhoto(args);
  };
};
